import React from 'react';

import { TabelaWidget } from './styles';
import { Table, Td, Th, Tr } from '../Tabela/styles';
import { ColunaTabela } from '../../types/Dashboard';
import { formatarValor } from '../../utils/formatadores';

export interface TabelaDadosProps {
  colunas: ColunaTabela[];
  linhas: Record<string, string | number>[];
}

// Tabela do widget `tabela` e "visão em tabela" de qualquer gráfico de série
export default function TabelaDados({ colunas, linhas }: TabelaDadosProps) {
  return (
    <TabelaWidget>
      <Table>
        <thead>
          <tr>
            {colunas.map(c => <Th key={c.campo} $numero={c.formato !== 'texto'}>{c.caption}</Th>)}
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha, i) => (
            <Tr key={i}>
              {colunas.map(c => (
                <Td key={c.campo} $numero={c.formato !== 'texto'}>{formatarValor(linha[c.campo], c.formato)}</Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </Table>
    </TabelaWidget>
  );
}
